/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
import {
    addcartItemViewListToStorage,
    createDataLayerItemAuth,
    createDataLayerItemAuthWithDiscount,
    createDataLayerItemCoveo,
    createDataLayerItemUnAuth,
    createInvoiceOrderLineDataLayerItemAuth,
    createInvoiceOrderLineDataLayerItemUnAuth,
    getcartItemViewListFromStorage,
} from "@NA/Utils/GtmUtility";
import { Session } from "@insite/client-framework/Services/SessionService";
import { CartLineModel, CartModel, OrderLineModel, ProductModel, ProductPriceDto, RealTimePricingModel } from "@insite/client-framework/Types/ApiModels";
import { GtmItemModel, CartItemsListDto } from "@NA/Types/GtmModel";
import { getUnitNetPrice, getPrice } from "@NA/Overrides/Services/ProductPriceService";
import toNumber from "lodash/toNumber"
import { CoveoProductModel } from "@NA/Types/CoveoModel";
// import { sendPurchaseEvent } from "@NA/Services/ADICoveoService"

let lastTrackedUrl = "";
// get global for google tag manager
function getDataLayer() {
    if (typeof window !== "undefined") {
        return (window as any).dataLayer;
    }
}
// get global for google analytics
function getGa() {
    return (window as any).ga;
}

export function customTrackPageChange() {
    if (IS_SERVER_SIDE) {
        return;
    }
    let url = window.location.pathname + window.location.search;
    if (window.location.pathname === '/search') {
        url = window.location.hash.includes("&")
            ? window.location.pathname + window.location.hash.substring(0, window.location.hash.indexOf("&"))
            : window.location.pathname + window.location.search;
    }
    if (url === lastTrackedUrl) {
        return;
    }

    lastTrackedUrl = url;

    const dataLayer = getDataLayer();

    if (dataLayer) {
        dataLayer.push({
            event: "virtualPageView",
            page: {
                title: window.document.title,
                url,
            },
        });
    } else {
        const ga = getGa();
        if (ga) {
            ga("set", "location", url);
            ga("set", "page", window.location.pathname + window.location.search);
            ga("send", "pageview");
        }
    }
}

export function pushAuthDataToDataLayer(customerNumber: string, session?: Session) {
    const dataLayer = getDataLayer();
    if (dataLayer) {
        const logged = session?.isAuthenticated === true ? "Logged In" : "Not Logged In";
        const userRoles = session?.userRoles != null ? session.userRoles.replace(/,/g, "|") : "";
        const userID = session?.isAuthenticated === true ? session?.properties["userId"] : "";
        customerNumber = customerNumber !== undefined ? customerNumber : "";
        if (session?.email != null && typeof window !== "undefined") {
            window.localStorage.setItem("userEmail", session.email);
        }
        const data = {
            "Authentication State": logged,
            "Customer Number": customerNumber,
            Role: userRoles,
            "User ID": userID,
        };
        dataLayer.push(data);
    }
}

export function pushDataToDataLayer(products: ProductModel[], listName: string, session?: Session,realTimePricing :RealTimePricingModel | undefined=undefined) {
    const dataLayer = getDataLayer();
    if (dataLayer && products) {
        const items: any[] = [];
        let categories: string[] = [];
        products.forEach((product, productIndex) => {
            let itemvariant ='';
            let priceVal=0;
            if(realTimePricing){
                const price = realTimePricing.realTimePricingResults?.filter(p=>p.productId === product.id)
                const qty = toNumber(product.qtyOrdered !== undefined && product.qtyOrdered != null && product.qtyOrdered !==0  ? product.qtyOrdered : (product.properties['minimuM_QTY'] || 1));
               if(price && price.length>0){
                  itemvariant = price[0].additionalResults?price[0].additionalResults['message']:'';
                  priceVal=getUnitNetPrice(price[0], qty).price;
               }
            } 
            if (
                product != null &&
                product.properties["datalayercategoryList"] !== undefined &&
                product.properties["datalayercategoryList"] != null &&
                product.properties["datalayercategoryList"] !== ""
            ) {
                categories = product.properties["datalayercategoryList"].split("/");
            }
            if (session?.isAuthenticated && product) {
                items.push(createDataLayerItemAuth(product, categories, listName, productIndex, itemvariant, priceVal));
            } else if (product) {
                items.push(createDataLayerItemUnAuth(product, categories, listName, productIndex));
            }
        });
        const data = {
            event: "view_item_list",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function pushDataToDataLayerCoveo(products: CoveoProductModel[], listName: string, isAuthenticated: boolean, currencyCode: string) {
    const dataLayer = getDataLayer();
    if (dataLayer && products) {
        const items: any[] = [];
        let categories: string[] = [];
        products.forEach((product, productIndex) => {
            let itemvariant ='';
            let priceVal=0;
            if(product?.pricing){
                const qty = product?.minimumOrderQty !== undefined && product?.minimumOrderQty != null ? product?.minimumOrderQty : 1;
                  itemvariant = product?.pricing?.additionalResults?.message ? product?.pricing?.additionalResults?.message : '';
                  const price = getPrice(
                    product?.pricing.unitRegularBreakPrices,
                    product?.pricing.unitNetPrice,
                    product?.pricing.unitNetPriceDisplay,
                    qty
                );
                   priceVal=price?.price;
            } 
            if (
                product != null &&
                product.category !== undefined && product.category != null
            ) {
                categories = Array.isArray(product?.category) && product?.category.length > 0 
                    ? (product?.category.slice(-1)[0] as string).split("|") 
                    : [];
            }
            if (isAuthenticated && product) {
                items.push(createDataLayerItemCoveo(product, categories, listName, productIndex, itemvariant, priceVal));
            } else if (product) {
                items.push(createDataLayerItemUnAuth(product, categories, listName, productIndex));
            }
        });
        const data = {
            event: "view_item_list",
            ecommerce: {
                currency: currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function addProductToCart(product: any, listName: string, session?: Session) {
    const listname = sessionStorage.getItem("item_list_name");
    sessionStorage.removeItem("item_list_name");
    const dataLayer = getDataLayer();
    if (product !== null && product !== undefined && dataLayer) {
        const items: any[] = [];
        let categories: string[] = [];
        if (
            product != null &&
            product.properties["datalayercategoryList"] !== undefined &&
            product.properties["datalayercategoryList"] != null &&
            product.properties["datalayercategoryList"] !== ""
        ) {
            categories = product.properties["datalayercategoryList"].split("/");
        }
        items.push(createDataLayerItemAuth(product, categories, listname != null ? listname : "",0, product.availability?.message || ""));
        addcartItemViewListToStorage(product.erpNumber, listname??"");
        const data = {
            event: "add_to_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function removeProductFromCart(product: any, listName: string, session?: Session) {
    const listname = sessionStorage.getItem("item_list_name");
    sessionStorage.removeItem("item_list_name");
    const dataLayer = getDataLayer();
    if (dataLayer) {
        const items: any[] = [];
        let categories: string[] = [];
        if (
            product != null &&
            product.properties["datalayercategoryList"] !== undefined &&
            product.properties["datalayercategoryList"] != null &&
            product.properties["datalayercategoryList"] !== ""
        ) {
            categories = product.properties["datalayercategoryList"].split("/");
        }
        items.push(createDataLayerItemAuth(product, categories, listname != null ? listname : "",0, product.availability?.message || ""));
        const data = {
            event: "remove_from_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function addToWishList(products: ProductModel[], listName: string,productInfo:any, session?: Session): void {
    let listOfName = sessionStorage.getItem("item_list_name") ?? "";
    const dataLayer = getDataLayer();
    const items: any[] = [];
    const data = {
        event: "add_to_wishlist",
        ecommerce: {
            currency: session?.currency?.currencyCode,
            items,
        },
    };
    if (dataLayer && products && dataLayer !== undefined) {
        products.forEach((product, productIndex) => {
            let categories: string[] = [];
            if (
                product.properties !== undefined &&
                product.properties["datalayercategoryList"] != null &&
                product.properties["datalayercategoryList"] !== ""
            ) {
                categories = product.properties["datalayercategoryList"].split("/");
            }if (session?.isAuthenticated && product != null) {
                const priceDisp = (productInfo.pricing != null && productInfo.pricing !== undefined ? getUnitNetPrice(productInfo.pricing, productInfo.qtyOrdered).price: 0);
                const item_variant=product.properties["inventoryMessage"];
                data.ecommerce.items.push(createDataLayerItemAuth(product, categories, listOfName, productIndex,item_variant, priceDisp));
            } else {
                data.ecommerce.items.push(createDataLayerItemUnAuth(product, categories, listOfName, productIndex));
            }
        });
        dataLayer.push(data);
    }
    sessionStorage.setItem("item_list_name", "");
}

export function pushDealerAuthDataToDataLayer(brand: string, vendorLink: string, customerNumber: string, pageName: string, session?: Session) {
    const dataLayer = getDataLayer();
    
    if (session?.isAuthenticated && vendorLink) {
        const items: any[] = [];
        items.push({
            'item_vendorlink': vendorLink,
            'item_customer': customerNumber,
            'item_brandname': brand,
            'item_cpage': pageName,
            'item_list_name': "",
        });

        const data = {
            event: "view_item_list",
            ecommerce: {
                'currency': session?.currency?.currencyCode,
                'items': items,
            },
        };
        dataLayer.push(data);
    }
}

export function pushQuoteOrderDetailsToDataLayer(
    invoiceOrderLines: OrderLineModel[],
    listName: string,
    session?: Session,
) {
    const dataLayer = getDataLayer();
    if (dataLayer && invoiceOrderLines) {
        const items: any[] = [];
        let categories: string[] = [];
        invoiceOrderLines.forEach((orderLine, productIndex) => {
            if (
                orderLine.properties["datalayercategoryList"] !== undefined &&
                orderLine.properties["datalayercategoryList"] != null &&
                orderLine.properties["datalayercategoryList"] !== ""
            ) {
                categories = orderLine.properties["datalayercategoryList"].split("/");
            }
            if (session?.isAuthenticated && orderLine) {
                items.push(createInvoiceOrderLineDataLayerItemAuth(orderLine, categories, listName, productIndex));
            } else {
                items.push(createInvoiceOrderLineDataLayerItemUnAuth(orderLine, categories, listName, productIndex));
            }
        });
        const data = {
            event: "view_item_list",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function pushProductDetailDataToDataLayer(
    product: any,
    eventName: string,
    itemListName: string,
    session?: Session,
    pricing?: ProductPriceDto
) {
    const dataLayer = getDataLayer();
    if (product !== null && product !== undefined && dataLayer) {
        let categories: string[] = [];
        const items: any[] = [];
        if (eventName === "view_item") {
            if (
                product != null &&
                product.properties["datalayercategoryList"] !== undefined &&
                product.properties["datalayercategoryList"] != null &&
                product.properties["datalayercategoryList"] !== ""
            ) {
                categories = product.properties["datalayercategoryList"].split("/");
            }
            if (session?.isAuthenticated && product) {
                const itemVarient = product.properties["inventoryMessage"];
                const priceVal= pricing?.unitRegularPrice;
                items.push(createDataLayerItemAuth(product, categories, "Product Detail", 0, itemVarient, priceVal));
            } else {
                items.push(createDataLayerItemUnAuth(product, categories, "Product Detail"));
            }
        } else {
            if (
                product != null &&
                product.properties["datalayercategoryList"] !== undefined &&
                product.properties["datalayercategoryList"] != null &&
                product.properties["datalayercategoryList"] !== ""
            ) {
                categories = product.properties["datalayercategoryList"].split("/");
            }
            if (session?.isAuthenticated && product) {
                // if(sessionStorage.getItem("itemListName")!== undefined && sessionStorage.getItem("itemListName")!=null ){
                //     itemListName=sessionStorage.get("itemListName");
                // }
                // else {
                //     const cartItems: CartItemsListDto[] = sessionStorage.getObject("cartItemViewList");
                //     const cartItem = cartItems?.filter(x => x.erpNumber === product.erpNumber && x.isFromProductLink === false)[0];
                //     if (cartItem) {
                //         itemListName = cartItem.viewListName;
                //     }
                //     else if (sessionStorage.get("qcItemListName") !== undefined && sessionStorage.get("qcItemListName").length > 0) {
                //         itemListName = sessionStorage.get("qcItemListName");
                //    }
                //     else {
                //         itemListName = "";
                //     }
                // }
                const itemVarient = product.properties["inventoryMessage"];
                const priceVal= pricing?.unitRegularPrice;
                items.push(createDataLayerItemAuth(product, categories, itemListName, 0, itemVarient,priceVal));
            } else {
                // itemListName = (sessionStorage.get("itemListName") !== undefined && sessionStorage.get("itemListName").length > 0) ? sessionStorage.get("itemListName") : "";
                items.push(createDataLayerItemUnAuth(product, categories, itemListName));
            }
            // sessionStorage.set("itemListName", "");
        }
        const data = {
            event: eventName,
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };

        dataLayer.push(data);
    }
}

export function pushCheckoutOptionDataToDataLayer(cartLines: any, session?: Session) {
    const dataLayer = getDataLayer();
    const items: any[] = [];
    let categories: string[] = [];
    if (dataLayer) {
        const cartItems: CartItemsListDto[] = getcartItemViewListFromStorage();
        cartLines.cartLines?.forEach((product: any, productIndex: number) => {
            const cartItem = cartItems?.filter(
                x => x.erpNumber === product.erpNumber && x.isFromProductLink === false,
            )[0];
            if (cartItem) {
                if (
                    product != null &&
                    product !== undefined &&
                    product.properties !== undefined &&
                    product.properties["datalayercategoryList"] != null &&
                    product.properties["datalayercategoryList"] !== ""
                ) {
                    categories = product.properties["datalayercategoryList"].split("/");
                }
                if (product != null && product !== undefined) {
                    items.push(createDataLayerItemAuthWithDiscount(product, categories, cartItem.viewListName ?? "", productIndex, '', product.availability?.message || ""));
                }
            } else {
                if (
                    product != null &&
                    product !== undefined &&
                    product.properties !== undefined &&
                    product.properties["datalayercategoryList"] != null &&
                    product.properties["datalayercategoryList"] !== ""
                ) {
                    categories = product.properties["datalayercategoryList"].split("/");
                }
                if (product != null && product !== undefined) {
                    items.push(createDataLayerItemAuthWithDiscount(product, categories, "", productIndex, '', product.availability?.message || ""));
                }
            }
        });
        const data = {
            event: "begin_checkout",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function pushOrderConfirmationDataToDataLayer(
    cart: CartModel,
    cartLines: CartLineModel[],
    promoCodes: string,
    session?: Session,
): void {
    const dataLayer = getDataLayer();
    let categories: string[] = [];
    const items: any[] = [];
    let shippingSelection: string;
    let branchLocationText: string;

if (cartLines.length > 0) {
        if (cart.properties["isPickUp"] === "Y") {
            branchLocationText =
                cart.properties["branchLocationText"] != null && cart.properties["branchLocationText"] !== ""
                    ? cart.properties["branchLocationText"].trim()
                    : "";
            shippingSelection = `${cart.carrier?.description} : ${branchLocationText}`;
        } else {
            shippingSelection = cart.properties["shippingSelection"];
            shippingSelection = `${cart.carrier?.description} : ${shippingSelection}`;
        }
        let _totalOrderAmount: number;
        if (cart.properties["totalOrderAmount"] != null && cart.properties["totalOrderAmount"] !== undefined) {
            _totalOrderAmount = parseFloat(cart.properties["totalOrderAmount"]);
            if (_totalOrderAmount === undefined) {
                _totalOrderAmount = 0;
            }
            if (Number.isNaN(_totalOrderAmount)) {
                _totalOrderAmount = 0;
            }
        } else {
            _totalOrderAmount = 0;
        }
        if (dataLayer) {
            const productIndex = 1;
            let cartItems: CartItemsListDto[] = getcartItemViewListFromStorage();
            const salePromoSavingItems = cart.properties["salePriceItems"] ?? "";
            const coupon=cart.properties["customerPromocode"] ?? "";
            const saleSavingItems = salePromoSavingItems !== "" ? salePromoSavingItems.split(":") : null;
            if (saleSavingItems != null) {
                for (let i = 0; i < saleSavingItems.length; i++) {
                    const saleERPNo = saleSavingItems[i].split(";")[0];
                    const discount = saleSavingItems[i].split(";")[1];
                    const salePrice = Number(saleSavingItems[i].split(";")[2]);
                    cartLines?.forEach(product => {
                        if (product.erpNumber.trim() === saleERPNo) {
                            product.properties['discount'] = discount;
                        }
                    });
                }
            }
            cartLines.forEach((product, productIndex) => {
                const cartItem = cartItems?.filter(
                    x => x.erpNumber === product.erpNumber && x.isFromProductLink === false,
                )[0];
                const discount = product.properties['discount'];
                // const _savings = 0;
                // if (product.pricing.promoSaving != null && product.pricing.promoSaving !== '') {
                //     _savings = parseFloat(product.pricing.promoSaving);
                //     if (_savings === undefined) {
                //         _savings = 0;
                //     }
                //     if (isNaN(_savings)) {
                //         _savings = 0;
                //     }
                // } else {
                //     _savings = 0;
                // }

                let itemListName: any;
                if (cartItem) {
                    itemListName = cartItem.viewListName;
                } else {
                    itemListName = "";
                }

                if (
                    product != null &&
                    product !== undefined &&
                    product.properties !== undefined &&
                    product.properties["datalayercategoryList"] != null &&
                    product.properties["datalayercategoryList"] !== ""
                ) {
                    categories = product.properties["datalayercategoryList"].split("/");
                }
                if (product != null && product !== undefined) {
                    items.push(
                        createDataLayerItemAuthWithDiscount(product, categories, itemListName, productIndex, discount, product.availability?.message || ""),
                    );
                }
            });
            const data = {
                event: "purchase",
                ecommerce: {
                    transaction_id: cart.orderNumber,
                    value: _totalOrderAmount,
                    tax: cart.totalTax,
                    shipping: session?.currency?.currencyCode,
                    currency: session?.currency?.currencyCode,
                    coupon, // promoCodes !== "" ? promoCodes.substring(0, promoCodes.length - 1) : "",
                    purchase_shippingMethod: cart.carrier?.description,
                    purchase_paymentMethod: cart.properties["paymentMethod"],
                    purchase_orderType: cart.type === "Quote" ? "quote to order" : "standard",
                    purchase_deliveryMethod: shippingSelection,
                    items,
                },
            };
            dataLayer.push(data);
            cartItems = [];
            sessionStorage.setItem("cartItemViewList", '');
        }
        // sendPurchaseEvent(cartLines, cart, _totalOrderAmount);
    }
}

export function viewProductsFromCart(cartLines: CartLineModel[], session?: Session) {
    const dataLayer = getDataLayer();
    if (
        cartLines != null &&
        cartLines.length > 0 &&
        dataLayer &&
        window.location.href.toLowerCase().indexOf("cart") !== -1
    ) {
        const items: any[] = [];
        const cartItems: CartItemsListDto[]= getcartItemViewListFromStorage();
        let categories: string[] = [];
        cartLines.forEach((product: any, productIndex) => {
            const cartItem = cartItems?.filter(
                x => x.erpNumber === product.erpNumber && x.isFromProductLink === false,
            )[0];
            if (cartItem) {
                if (
                    product != null &&
                    product !== undefined &&
                    product.properties !== undefined &&
                    product.properties["datalayercategoryList"] != null &&
                    product.properties["datalayercategoryList"] !== ""
                ) {
                    categories = product.properties["datalayercategoryList"].split("/");
                }
                if (product != null && product !== undefined) {
                    items.push(createDataLayerItemAuthWithDiscount(product, categories, cartItem.viewListName ?? "", productIndex, '', product.availability?.message || ""));
                }
            } else {
                if (
                    product != null &&
                    product !== undefined &&
                    product.properties !== undefined &&
                    product.properties["datalayercategoryList"] != null &&
                    product.properties["datalayercategoryList"] !== ""
                ) {
                    categories = product.properties["datalayercategoryList"].split("/");
                }
                if (product != null && product !== undefined) {
                    items.push(createDataLayerItemAuthWithDiscount(product, categories, "", productIndex, '', product.availability?.message || ""));
                }
            }
        });
        const data = {
            event: "view_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                items,
            },
        };
        dataLayer.push(data);
    }
}

export function addProductCollectionToCart(products: any, listName: string, session?: Session): void {
    const listname = sessionStorage.getItem("item_list_name") ?? "";
    const dataLayer = getDataLayer();
    const items: any[] = [];
    if (products != null && products.length > 0) {
        if (dataLayer) {
            products.forEach((product:any, productIndex:number) => {
                let categories: string[] = [];
                if (
                    product.properties !== undefined &&
                    product.properties["datalayercategoryList"] != null &&
                    product.properties["datalayercategoryList"] !== ""
                ) {
                    categories = product.properties["datalayercategoryList"].split("/");
                }
                if (session?.isAuthenticated && product != null) {
                    items.push(createDataLayerItemAuth(product, categories, listname != null ? listname : "", productIndex, product.availability?.message || ""));
                } 
            });
            sessionStorage.removeItem("item_list_name");
            const data = {
                event: "add_to_cart",
                ecommerce: {
                    currency: session?.currency?.currencyCode,
                    items,
                },
            };
            dataLayer.push(data);
        }
    }
}
